export default function interpolate(template: string, params?: Record<string, unknown>) {
  const names = params ? Object.keys(params) : [];
  const values = params ? Object.values(params) : [];
  return new Function(...names, `return \`${template}\`;`)(...values);
}
